<template>
    <div id="map-btn-tool" ref="map-btn-tool" class="map-btn-tool map-high-item">
        <div v-for="(btn_list, group) in this.config.button" 
            :key="group" 
            class="map-btn-group"
            @mouseover="show_text[group] = true" 
            @mouseout="show_text[group] = false"
        >
            <map-btn
                v-for="btn in btn_list"
                :key="btn.name"
                :name="btn.name"
                :title="btn.title"
                :is_disabled="btn_map[btn.name].disabled"
                @click="click_btn(btn.name)"
            >
                <template v-slot:map-btn-text>
                    <span v-show="show_text[group] && show_menu == null" class="map-btn-text">{{ btn.title }}</span>
                </template>

                <template v-slot:map-btn-menu>
                    <map-btn-menu
                        :key="basemap_key"
                        v-if="btn.name == 'boundary'"
                        v-show="show_menu == btn.name"
                        :input_type="'basemap_boundary'"
                        :name="btn.name"
                        :title="btn.title"
                        :data="basemap_boundary_config.item"
                        :default_val="basemap_boundary_config.default"
                        @change_basemap="change_basemap"
                        @change_boundary="change_boundary"
                        @close="show_menu = null"
                    ></map-btn-menu>

                    <!-- <map-btn-menu
                        :key="order_tool_key"
                        v-else-if="btn.name == 'order'"
                        v-show="show_menu == btn.name"
                        :input_type="'dragable'"
                        :name="btn.name"
                        :title="btn.title"
                        :data="order_tool"
                        @change="change_order"
                        @close="show_menu = null"
                    ></map-btn-menu>

                    <map-btn-menu
                        :key="opacity_tool_key"
                        v-else-if="btn.name == 'opacity'"
                        v-show="show_menu == btn.name"
                        :input_type="'range'"
                        :name="btn.name"
                        :title="btn.title"
                        :data="opacity_tool.data"
                        :set_val="opacity_tool.set_val"
                        @change="change_opacity"
                        @close="show_menu = null"
                    ></map-btn-menu> -->
                </template>
            </map-btn>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MapBtn from './map-btn.vue' //地圖按鈕元件
import MapBtnMenu from './map-btn-menu.vue' //地圖按鈕選單

export default {
    name: 'map-btn-tool',

    components: {
        'map-btn': MapBtn,
        'map-btn-menu': MapBtnMenu,
    },

    props: ['config', 'map_zoom', 'opacity_tool', 'order_tool'],
    data: function() {
        return {
            btn_map: {}, //按鈕狀態對照表
            show_text: {}, //顯示輔助文字
            show_menu: null, //目前顯示的選單
        }
    },

    computed: {
        ...mapGetters([
            'is_mobile_width'
        ]),
        area_bounds() {
            return {
                small_area: this.config.area_bounds.small_area,
                large_area: this.config.area_bounds.large_area,
            }
        },
        zoom_limit() {
            return {
                min: this.config.options.minZoom,
                max: this.config.options.maxZoom,
            }
        },
        basemap_boundary_config() {
            return {
                default: this.config.basemap_boundary ? this.config.basemap_boundary.map( item => item.default) : [],
                item: this.config.basemap_boundary ? this.config.basemap_boundary.map( Ob => Ob.item ) : [],
            }
        },
        basemap_config() {
            return {
                default: this.config.basemap ? this.config.basemap.default : '',
                list: this.config.basemap ? this.config.basemap.list : [],
            }
        },
        boundary_config() {
            return {
                default: this.config.boundary ? this.config.boundary.default : [],
                list: this.config.boundary ? this.config.boundary.list : [],
            }
        },
        basemap_key: function () {
            return this.get_key(this.basemap_config.list)
        },
        boundary_key: function () {
            return this.get_key(this.boundary_config.list)
        },
        order_tool_key: function () {
            return this.get_key(this.order_tool)
        },
        opacity_tool_key: function () {
            return this.get_key(this.opacity_tool.data)
        },
    },

    watch: {
        map_zoom: function (zoom) {
            if (!this.btn_map['zoom_in'] || !this.btn_map['zoom_out']) {
                return
            }
            if (zoom === this.zoom_limit.max) {
                this.btn_map['zoom_in'].disabled = true
            } else if (zoom === this.zoom_limit.min) {
                this.btn_map['zoom_out'].disabled = true
            } else {
                this.btn_map['zoom_in'].disabled = false
                this.btn_map['zoom_out'].disabled = false
            }
        },

        'config.btn': {
            immediate: true,
            deep: true,
            handler() {
                this.init_show_text()
            }
        },
    },
    beforeMount: function() {
        for (let group in this.config.button) {
            for (let btn of this.config.button[group]) {
                this.$set(this.btn_map, btn.name, {
                    disabled: false, //按鈕禁用
                })
            }
        }
    },
    mounted: function() {
        // 點擊其他地方 => 隱藏menu
        $(document).mouseup((e) => {
            var container = $(this.$refs['map-btn-tool']) //排除的目標

            if (!container.is(e.target) && container.has(e.target).length === 0) {
                this.show_menu = null
                this.modify_zIndex('.map-top-right-ctrl', 'auto')
            }
        })
    },
    
    methods: {
        get_key: function(data) {
            return $.map(data, (o) => {
                return o.name
            }).join()
        },
        click_btn: function(name) {
            if (this.show_menu == name) {
                this.show_menu = null
                this.modify_zIndex('.map-top-right-ctrl', 'auto')
                return
            }

            if (name === 'zoom_in') {
                this.$emit('zoom_in')
            } else if (name === 'zoom_out') {
                this.$emit('zoom_out')
            } else if (name === 'small_area') {
                this.$emit('fit_bounds', this.area_bounds[name])
            } else if (name === 'large_area') {
                if (this.is_mobile_width) {
                    return this.$emit('set_map_view', {
                        latlng: this.config.options.center, 
                        zoom: this.config.options.minZoom
                    })
                }
                this.$emit('fit_bounds', this.area_bounds[name])
            } else if (name === 'capture') {
                this.$emit('capture')
            } else if (name === 'measure') {
                this.$emit('toggle_measure_tool')
            } else if (name === 'boundary') {
                this.modify_zIndex('.map-top-right-ctrl', 'auto')
                this.show_menu = name
            } else {
                this.show_menu = name //選單式按鈕
            }
        },
        change_basemap: function(basemap) {
            this.$emit('change_basemap', basemap)
        },
        change_boundary: function(list, boundary, status) {
            this.$emit('toggle_boundary', boundary, status)
        },
        change_opacity: function(name, val) {
            this.$emit('change_opacity', name, val)
        },
        change_order: function(list) {
            this.$emit('change_order', list)
        },
        init_show_text() {
            this.show_text = Object.keys(this.config.button)
                .reduce((accumulator, item) => {
                    return {
                        ...accumulator, 
                        [item]: false
                    }
                }, {})
        },
        modify_zIndex(selector, value) {
            const dom = document.querySelector(selector)
            dom.style.zIndex = value 
        }
    }
}
</script>

<style>
.map-btn-tool {
    font-size: 1em;
    font-family: var(--font-family);
    margin: 0.5rem 0 0;
    padding: 0.5rem 0.25rem;
    border-radius: 1rem;
    box-shadow: 0.25rem 0 1rem, 0 rgba(0, 0, 0, 0.32);
    background-color: var(--base-dark-blue);
}
.map-btn-group {
    margin-bottom: 0.7em;
}
.map-btn-text {
    position: absolute;
    right: 2.5rem;
    padding: 0.4em 0.8em;
    margin-left: 4em;
    font-size: 0.8em;
    overflow: initial;
}
</style>